import type {Values} from '@wix/devzai-utils-common';

/**
 * Layout size options for the products grid.
 * Uses responsive grid with min/max width constraints on items.
 * 
 * - Small: Smaller product cards (min 150px on mobile for 2-column grid, ~280px on tablet)
 * - Medium: Medium product cards (min 380px, fluid max) - default
 */
export const DoppeProductsGridLayoutSize = {
    Small: 'Small',
    Large: 'Medium',
} as const;

export type DoppeProductsGridLayoutSize = Values<typeof DoppeProductsGridLayoutSize>;

